<template>
  <div id="modalOverlay">
      <div id="modalWindow">
        <div class="row">
          <div class="col-sm-12" style="margin-bottom: 15px;">
            <h3>Edit Gas</h3>
          </div>
        </div>
        <form @submit.prevent="editGas">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label>Date</label>
              </div>
              <div class="col-sm-8">
                <date-picker
                  v-model="gas.date"
                  format="YYYY-MM-DD"
                  type="date"
                  valueType="format"
                ></date-picker>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Engineer</label>
              </div>
              <div class="col-sm-8">
                <div class="commerceSelect">
                  <select v-model="gas.engineer">
                    <option value="Will Rae">Will Rae</option>
                    <option value="Ben White">Ben White</option>
                    
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Type</label>
              </div>
              <div class="col-sm-8">
                <div class="commerceSelect">
                  <select v-model="gas.type">
                    <option value="Addition">Add Gas</option>
                    <option value="Removal">Remove Gas</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-sm-4">
                <label>Amount of Gas (Kg)</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="gas.amount_gas" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label>Reason</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="gas.reason" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div align="right">
                  <input type="submit" value="Edit Gas" />
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
        <router-link :to="{name: 'AssetsFgas', params: { id: this.$route.params.id }}"><font-awesome-icon icon="plus" class="modalClose" /></router-link>
      </div>
    </div>
</template>

<script>

import axios from 'axios'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: { DatePicker },
  data () {
    return {
      gas: {}
    }
  },
  created () {
    axios
      .get(`/api/fgas/leakcheck/${this.$route.params.aid}`)
      .then((res) => {
        this.gas = res.data
      })
  },
  methods: {
    editGas () {
     axios
        .put(`/api/fgas/leakcheck/${this.$route.params.aid}`, this.gas)
        .then(response => (
          this.$toast.success("Gas movement saved", {}),
          this.$router.push({ name: 'AssetsFgas', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    }
  }
}
</script>
